<template>
  <v-text-field v-model="editorValue" ref="periodEditorField" :dense="dense" :disabled="disabled" :label="label" :outlined="outlined" :clearable="!required" append-icon="mdi-calendar-weekend" @input="()=>{}" @click:append="visible=true" @blur="onBlur" @click:clear="onClear">
    <template v-slot:prepend-inner>
      <v-menu :activator="$refs.periodEditorField" :open-on-click="false" v-model="visible" transition="scale-transition" :close-on-content-click="false" max-width="290">
        <v-date-picker v-model="pickerValue" type="month" locale="zh" @input="onPicked"></v-date-picker>
      </v-menu>
    </template>
  </v-text-field>

</template>
<script>
import EditorProps from '../EditorProps';
export default {
  name: 'period-editor',
  props: { ...EditorProps.custom, ...EditorProps.vuetify },
  data () {
    return {
      visible: false,
      editorValue: this.value,
      pickerValue: this.value,
      oldValue: this.value
    }
  },
  methods: {
    onBlur () {
      this.editorValue = this.Utility.fmtPeriod2(this.editorValue);
      this.pickerValue = this.editorValue;
      this.triggerChange();
    },
    onPicked () {
      this.visible = false;
      this.editorValue = this.pickerValue;
      this.triggerChange();
    },
    onClear () {
      this.pickerValue = this.editorValue;
      this.triggerChange();
    },
    triggerChange () {
      this.$emit('input', this.editorValue);
      this.$emit('change', this.oldValue, this.editorValue);
      this.oldValue = this.editorValue;
    }
  }
}
</script>